/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { INIT_ERRORS_FORM, INIT_FORM, OPTIONAL_FIELDS } from "../constants";
import { RESOURCES_CONSTANTS } from "config/constants";

const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;

const useElectronicResourceForm = ({
    currentResourceForUpdate,
    resourceTypeIdToCreate,
    campusFilterSelectedId
}) => {
    //#region States
    const [form, setForm] = useState({ ...INIT_FORM });
    const [errorsForm, setErrorsForm] = useState({ ...INIT_ERRORS_FORM });
    const [isResource, setIsResource] = useState({
        tablet: false,
        pc: false
    });
    //#endregion
    //#region Effects
    useEffect(() => {
        setPreselectedData();
    }, []);
    useEffect(() => {
        if (!currentResourceForUpdate) return;
        setForm({ ...currentResourceForUpdate });
    }, [currentResourceForUpdate]);
    useEffect(() => {
        setIsResource({
            tablet: form.resourceTypeId === RESOURCE_TYPES_IDS.TABLET,
            pc: form.resourceTypeId === RESOURCE_TYPES_IDS.PC
        });
    }, [form.resourceTypeId]);
    //#endregion
    //#region Functions
    function setPreselectedData() {
        setForm({
            ...form,
            resourceTypeId: resourceTypeIdToCreate.value,
            campusId: campusFilterSelectedId
        });
    }
    const changeField = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: typeof (value) === "function" ? value(prev[field]) : value
        }));
        if (OPTIONAL_FIELDS.includes(field)) return;
        setErrorsForm(prev => ({
            ...prev,
            [field]: false
        }));
    }
    const toggleActiveField = () => {
        changeField("active", prev => !prev);
    }
    const areThereChanges = () => {
        if (!currentResourceForUpdate) return true;
        const {
            brandId,
            barcode,
            details
        } = currentResourceForUpdate;
        let result = (
            form.brandId !== brandId ||
            form.barcode.trim() !== barcode.trim() ||
            form.details.trim() !== details.trim()
        );
        if (isResource.tablet) {
            const {
                model,
                serial
            } = currentResourceForUpdate;
            result = (
                result || 
                form.model.trim() !== model.trim() || 
                form.serial.trim() !== serial.trim()
            );
        }
        return result;
    }
    const isCompletedForm = () => {
        const {
            campusId,
            libraryId,
            resourceTypeId,
            brandId,
            barcode
        } = form;
        let result = (
            campusId !== 0 && 
            libraryId !== 0 &&
            resourceTypeId &&
            brandId !== 0 &&
            barcode.trim()
        );
        if (isResource.tablet) {
            const {
                model,
                serial
            } = form;
            result = (
                result &&
                model && 
                serial
            );
        }
        return result;
    }
    //#endregion
    return {
        value: form,
        set: setForm,
        errors: {
            value: errorsForm,
            set: setErrorsForm
        },
        isResource,
        change: changeField,
        toggleActiveField,
        areThereChanges,
        isCompleted: isCompletedForm
    }
}

export default useElectronicResourceForm;